import {createApp} from 'vue';
import {getPinia} from './stores/pinia.ts';
import App from './App.vue';
import ProjectView from './components/project-view/ProjectView.vue';
import {globalContainer} from '../container.ts';
import {initAllSpiceAppStore} from './store.ts';
import '../../css/repo.css';
import {event} from '../analytics.ts';
import {allspiceCookies, COOKIE_NAMES} from '../allspice-cookies.ts';
import {featureFlag} from './lib/feature-flag.ts';

/**
 * Initialize Project View on the page.
*/
export async function initAllspiceProjectView() {
  if (featureFlag('projectViewV2')) {
    return initAllspiceProjectViewV2();
  }
  return initAllspiceProjectViewV1();
}

/**
 * Initialize Project View v2.
*/
export async function initAllspiceProjectViewV2() {
  const app = createApp(ProjectView);
  app
    .use(getPinia());

  app.mount('#allspice-app-mount');
}

/**
 * Initialize the Allspice Design Review application. This is a ECad review tool.
 */
export async function initAllspiceProjectViewV1() {
  const data = document.querySelector('#allspice-data');
  if (!data || !data.textContent) {
    return;
  }
  const fileTree = JSON.parse(data.textContent);
  const store = initAllSpiceAppStore(fileTree.diffTree, fileTree.diffInfo, fileTree.previewURLs, fileTree.prInfo, fileTree.warnings, globalContainer, fileTree.diffFilterConfig);

  const setActivePath = () => {
    store.activePath.value = window.location.hash;
  };
  window.addEventListener('hashchange', setActivePath);

  const queryString = window.location.search;
  const queryParameters = new URLSearchParams(queryString);
  const anchor = queryParameters.get('anchor');

  // Support snippet references which require a view-coordinates query parameter.
  // In this case, we will always navigates the provided anchor
  if (queryParameters.has('view-coordinates') && anchor && window.location.hash === '') {
    const docId = queryParameters.get('doc-id');
    if (docId) {
      window.location.hash = `#${anchor}_${docId}`;
    } else {
      window.location.hash = `#${anchor}`;
    }
  }

  setActivePath();

  const app = createApp(App);
  app
    .use(getPinia())
    .provide('store', store)
    .provide('container', globalContainer)
    .provide('fetcher', globalContainer.lookup('fetcher'))
    .mixin({
      mounted() {
        this.$el.__vueComponent = this;
      },
    });

  app.mount('#allspice-app-mount');
}

export async function initAllspiceProjectViewSwitcher() {
  const element = document.querySelector('#enable-project-view');
  if (element) {
    element.addEventListener('click', () => {
      event('project_view_enabled');
      allspiceCookies.set(COOKIE_NAMES.PROJECT_VIEW, 'true');
      window.location.reload();
    });
  }
}
